export default {
    hint: 'No initiators found. Please use [enter] to add',
    loading: 'Please wait, load data...',
    search: 'Please enter two letters to search'
}
